import { Box, Center, Flex } from "@chakra-ui/react";
import { PropsWithChildren, ReactNode, useContext } from "react";
import { MapProvider } from "react-map-gl/maplibre";

import { SIZES } from "@nens/ranalib";
import { TenantContext } from "@nens/ranalib";
import { RanaPageTitle } from "@nens/ranalib";

import { Sidebar } from "@/features/sidebar";
import { ProjectContext } from "@/stores/project-provider";

interface BasePageProps {
  activeSidebarButton?: string;
  pageSubTitle: ReactNode;
}

export const BASE_PAGE_ID = "base-page";
export const BASE_PAGE_OVERFLOW_ID = "base-page-overflow";

export function BasePage({
  activeSidebarButton,
  pageSubTitle,
  children,
}: PropsWithChildren<BasePageProps>) {
  const { name } = useContext(ProjectContext);
  const { isPublic } = useContext(TenantContext);

  return (
    <Flex w="full" h="vh">
      {pageSubTitle && <RanaPageTitle subTitle={pageSubTitle} projectName={name} />}
      {!isPublic && <Sidebar activeButton={activeSidebarButton} />}
      <MapProvider>
        <Box id={BASE_PAGE_OVERFLOW_ID} overflowY="auto" w="full" h="full" minH="full">
          <Center h="fit" w="full">
            <Flex
              h="fit"
              gap={2}
              width={`calc(min(${SIZES["7xl"]}, 80%))`}
              py={11}
              flexDirection="column"
            >
              {children}
            </Flex>
          </Center>
        </Box>
      </MapProvider>
    </Flex>
  );
}
